import {getInitialMeta} from "@helpers/HelperInitialPageState";
// Data file for component
///////////////////////////////////////////////////////////////////////////////////////////

const BG = {
	blockTitle: 'Какво ни отличава?',
	blockDesc: 'Създаваме решения, адаптирани към индивидуалните нужди на бизнеса.',
	blockContent:
	  [
		  {
			  title: 'Локална експертиза',
			  text: 'Съчетаваме дългогодишния си опит на българския пазар с най-добрите практики от европейската технологична група team.blue',
		  },
		  {
			  title: 'Сигурност и надеждност',
			  text: 'Нашата инфраструктура и процесите за защита гарантират, че онлайн проектите на клиентите са винаги защитени и достъпни.',
		  },
		  {
			  title: 'Поддръжка без аналог',
			  text: 'Екипът ни е до теб 24/7 - по телефон, чат и имейл. Ще съдействаме на всеки клиент с персонално и професионално отношение.',
		  }
	  ]
}

///////////////////////////////////////////////////////////////////////////////////////////

const EN = {
	blockTitle: 'What sets us apart?',
	blockDesc: 'We create solutions tailored to the individual needs of each business.',
	blockContent:
	  [
		  {
			  title: 'Local expertise',
			  text: 'We combine our long-standing experience in the Bulgarian market with the best practices of the European technology group team.blue.',
		  },
		  {
			  title: 'Security and reliability',
			  text: 'Our infrastructure and security processes ensure that our clients’ online projects are always protected and accessible.',
		  },
		  {
			  title: 'Unmatched support',
			  text: 'Our team is by your side 24/7 - via phone, chat, and email. We assist every client with a personal and professional approach.',
		  }
	  ]
}

///////////////////////////////////////////////////////////////////////////////////////////

const dataMap = {
	bg: BG,
	en: EN
};
const lang = getInitialMeta('pageLang') ?? 'bg';

///////////////////////////////////////////////////////////////////////////////////////////

export default dataMap[lang];